import React from 'react';
import { Button } from '@ofself/shell';
import './NucleusPage.css';
import './SheetFoot.css';

// THE FOOT of every sheet, dialog and form band: its buttons in one row, the
// primary at the far end (Save, Done), anything destructive at the left, the
// rest just before the primary.
//
//   <SheetFoot left={<FootButton danger …>Delete</FootButton>}>
//       <FootButton onClick={onClose}>Cancel</FootButton>
//       <FootButton primary type="submit" busy={saving}>Save</FootButton>
//   </SheetFoot>
//
// A FootButton is the kit's Button drawn as the ActionBar's block (nx-action):
// an edged word, the primary filled in the layer's hue, danger in live red.
// `busy` dims the word and breathes an ellipsis after it (no spinner), and
// takes the press away until the work is done.

export function SheetFoot({ children, left = null, className = '' }) {
    return (
        <div className={`nx-foot${className ? ` ${className}` : ''}`}>
            {left}
            <span className="nx-foot__spring" />
            {children}
        </div>
    );
}

export function FootButton({ primary = false, danger = false, busy = false, disabled = false, icon, type = 'button', className = '', children, ...rest }) {
    return (
        <Button
            type={type}
            variant={primary ? 'solid' : 'outline'}
            tone={danger ? 'danger' : 'neutral'}
            busy={busy}
            disabled={disabled}
            leading={icon}
            className={`nx-action nx-foot__btn${primary ? ' is-primary' : ''}${danger ? ' is-danger' : ''}${className ? ` ${className}` : ''}`}
            {...rest}
        >
            {children}
        </Button>
    );
}

export default SheetFoot;
